import type { Meal } from '@/models/meal'
import './product-card.scss'
import * as Dialog from '@radix-ui/react-dialog'
import dayjs from 'dayjs'
import { Icon } from '@/components/Icon'
import { useEffect, useState } from 'react'
import { displayMealProperties } from '../Calendar/WeekFlyout/MyMeals/myMeals.helper'

const ProductModal = ({
  meal,
  mealList,
  index,
}: {
  meal: Meal
  mealList: Meal[]
  index: number
}) => {
  const [currentMeal, setCurrentMeal] = useState<Meal>(meal)
  const [currentIndex, setCurrentIndex] = useState<number>(index)
  const [properties, setProperties] = useState<string>('')

  const prevMeal = () => {
    setCurrentIndex((currentIndex - 1 + mealList.length) % mealList.length)
  }

  const nextMeal = () => {
    setCurrentIndex((currentIndex + 1) % mealList.length)
  }

  useEffect(() => {
    setCurrentMeal(mealList[currentIndex])
  }, [currentIndex])

  useEffect(() => {
    setCurrentMeal(meal)
    setProperties(displayMealProperties(meal.properties))
  }, [meal])

  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>
        <button
          className="nwm-product-card__button"
          onClick={() => {
            setCurrentIndex(index)
          }}
        >
          See Details
        </button>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="dialog__overlay" />
        <Dialog.Content className="dialog__content">
          <div className="dialog__content__wrapper">
            <Dialog.Description className="dialog__content__title">
              <div className="dialog__content__title__imgContainer">
                <img src={currentMeal.dayImageUrl} alt={currentMeal.title} />
              </div>
              <div className="dialog__content__title__content">
                <label className="dialog__content__title__content__date">
                  {dayjs(currentMeal.date).format('dddd, MMMM D')}
                </label>
                <h4>{currentMeal.title}</h4>
                <label className="dialog__content__title__content__description">
                  {currentMeal.description}
                </label>
                <span className="dialog__content__title__content__properties">
                  {properties}
                </span>
              </div>
            </Dialog.Description>
            <Dialog.Description className="dialog__content__description">
              Ingredients: {currentMeal.ingredients}
            </Dialog.Description>
          </div>
          <Dialog.Description className="dialog__content__footer">
            <button
              className="dialog__content__footer__button"
              onClick={prevMeal}
            >
              <Icon name="left-arrow" viewBox="0 0 12 12" />
              <label>Previous Meal</label>
            </button>
            <button
              className="dialog__content__footer__button"
              onClick={nextMeal}
            >
              <label>Next Meal</label>
              <Icon name="right-arrow" viewBox="0 0 12 12" />
            </button>
          </Dialog.Description>
          <Dialog.Close asChild>
            <button className="dialog__iconButton" aria-label="Close">
              <Icon name="cross" />
            </button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

export const ProductCard = ({
  index,
  meal,
  mealList,
}: {
  index: number
  meal: Meal
  mealList: Meal[]
}) => {
  const { dayImageUrl: image, description, properties, title } = meal

  return (
    <div className="nwm-product-card">
      <div className="nwm-product-card__image">
        {meal.new && (
          <div className="nwm-product-card__new-meal-container">
            <p className="nwm-product-card__new-meal-badge">NEW MEAL</p>
          </div>
        )}
        <img src={image} alt={title} />
      </div>
      <div className="nwm-product-card__content">
        <h4>{title}</h4>
        <label className="nwm-product-card__content__description">
          {description}
        </label>
        <label className="nwm-product-card__content__properties">
          {displayMealProperties(properties)}
        </label>
      </div>
      <div>
        <ProductModal meal={meal} mealList={mealList} index={index} />
      </div>
    </div>
  )
}
